import { render, staticRenderFns } from "./termsAndPrivacy.vue?vue&type=template&id=7ab25214"
import script from "./termsAndPrivacy.vue?vue&type=script&lang=js"
export * from "./termsAndPrivacy.vue?vue&type=script&lang=js"
import style0 from "./termsAndPrivacy.vue?vue&type=style&index=0&id=7ab25214&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports